import React, { Component } from "react";
import TimeField from "react-simple-timefield";
import propTypes from "prop-types";
import "react-quill/dist/quill.snow.css";

export default class extends Component {
  static propTypes = {
    time: propTypes.array.isRequired,
    validationError: propTypes.string.isRequired,
    onChangeItem: propTypes.func.isRequired,
    weekDays:propTypes.array.isRequired,
  };

  render() {
    const { weekDays,time,validationError } = this.props;
    return (
      <div
        className={
          "office-form__working-time working-time" +
          (validationError && " has-error")
        }
      >
        <div className="working-time__title">Время работы</div>
        {weekDays.map((weekDayLabel, idx) => (
          <div className="working-time__item" key={`week_day_${idx}`}>
            <label htmlFor={`week_day_${idx}_start`}>{weekDayLabel}</label>
            <TimeField
              id={`week_day_${idx}_start`}
              value={(time[idx] || [])[0] || "00:00"}
              colon=":"
              style={{ width: "60px" }}
              className="timeField"
              onChange={time => this.props.onChangeItem(idx,0,time)}
            />
            <TimeField
              id={`week_day_${idx}_end`}
              value={(time[idx] || [])[1] || "00:00"}
              colon=":"
              style={{ width: "60px" }}
              className="timeField"
              onChange={time => this.props.onChangeItem(idx,1,time)}
            />
          </div>
        ))}
        {validationError && (
          <span className="text-danger">{validationError}</span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/theatre/_workTime.jsx